import React from 'react';

function About() {
  const features = [
    { icon: '🎓', title: 'Experienced Faculty', desc: '50+ highly qualified professors and clinical instructors' },
    { icon: '🏥', title: 'Modern Labs', desc: 'Advanced simulation labs and clinical training facilities' },
    { icon: '📚', title: 'Updated Curriculum', desc: 'Industry-aligned curriculum with hands-on training' },
    { icon: '🌍', title: 'Global Recognition', desc: 'Degrees recognized worldwide with international collaborations' },
    { icon: '💼', title: '100% Placement', desc: 'Dedicated placement cell with top hospital partnerships' },
    { icon: '🏆', title: 'NAAC A++', desc: 'Accredited with highest grade by NAAC' },
  ];

  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <h2 className="section-title">
          <span className="title-icon">ℹ️</span> About Our College
        </h2>
        <div className="about-content">
          <div className="about-text">
            <h3>25 Years of Excellence in Nursing Education</h3>
            <p>
              Hope Nursing College, established in 2001, is a premier institution dedicated
              to producing world-class nursing professionals. Affiliated with the State
              University of Health Sciences and recognized by the Indian Nursing Council,
              we provide comprehensive education that combines theoretical knowledge with
              practical clinical experience.
            </p>
            <p>
              Our state-of-the-art campus features modern simulation labs, a well-stocked
              library, comfortable hostels, and partnerships with 20+ hospitals for clinical
              training. We believe in nurturing compassionate, skilled, and ethical
              healthcare professionals.
            </p>
            <div className="about-highlights">
              <div className="highlight">
                <span className="highlight-number">20+</span>
                <span>Partner Hospitals</span>
              </div>
              <div className="highlight">
                <span className="highlight-number">15+</span>
                <span>Research Papers</span>
              </div>
              <div className="highlight">
                <span className="highlight-number">100+</span>
                <span>Events/Year</span>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="image-placeholder">
              <span className="image-icon">🏫</span>
              <p>College Campus</p>
            </div>
          </div>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <span className="feature-icon">{feature.icon}</span>
              <h4>{feature.title}</h4>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;